import * as API from "@/api/index.js"

export default {
  name: "user-role-transfer",
  components: {

  },

  model:{
    prop:"selection",
    event:"change",
  },

  props: {
    selection: {

    },

    data_url: {
        type: String,
        default: "/omnis/system/role",   // 角色源数据接口路由
    },

    data_req_param:{
      type: Object,
      default: function () {
        return {}    // 角色源数据接口参数
      }
    },

  },

  data() {

    return {
      data_selected: [],   // 选择的数据
      filterMethod(query, item) {
           return (item.pinyin.indexOf(query) > -1) ||( item.role_des &&　item.role_des.indexOf(query) > -1) ;
      },
      data_loading: false,
      data_all: [],   // 源数据
    }
  },
  mounted() {

    this.get_all_data();

  },

  computed: {},

  watch: {

    selection: {
      handler(data){
        this.data_selected = data;
      },
      deep:true,
    },

    data_selected: {
      handler(data){
        let data_details = this.data_all.filter(item => data.indexOf(item.role_id) > -1)
        this.$emit("change", data);
        this.$emit("data_change", data_details);
      },
      deep:true,
    },

  },

  methods: {
    get_all_data(){
      if (this.data_all.length === 0){
        this.all_data_req()
      }
    },

    async all_data_req() {
        this.data_loading = true
        const response = await API.GET(this.data_url, this.data_req_param)
        this.data_loading = false
        let data = response.data
        if (data.success) {
          this.data_all = data.data
          this.data_selected = this.selection;

        }
      },

  },

}



// WEBPACK FOOTER //
// ./src/omnis-business/user-role-transfer/user-role-transfer.js